// extracted by mini-css-extract-plugin
module.exports = {"form-b-wizard-submit":"style_form-b-wizard-submit__mJnkT"};